import { Box, BoxProps } from '@chakra-ui/react';

export default function BoxDivider(props: BoxProps) {
  return (
    <Box
      pos="absolute"
      bottom={0}
      left={0}
      w="100vw"
      h="68px"
      opacity="0.15"
      bg="linear-gradient(0deg, #D8D8E1 0%, rgba(216, 216, 225, 0.00) 82.14%)"
      {...props}
    />
  )
}
